export const ICONS = {
  discord: "https://pulsarmoney.b-cdn.net/icons/social/dicord.png",
  github: "https://pulsarmoney.b-cdn.net/icons/social/github.png",
  telegram: "https://pulsarmoney.b-cdn.net/icons/social/telegram.png",
  x: "https://pulsarmoney.b-cdn.net/icons/social/x.png",
  revaIcon: "https://pulsarmoney.b-cdn.net/reveel-gamification/image%20(5).png",
  point: "https://pulsarmoney.b-cdn.net/reveel-gamification/point.png",
  joinCampaign:
    "https://pulsarmoney.b-cdn.net/reveel-gamification/join-campaign-blue.png",
  referFriend:
    "https://pulsarmoney.b-cdn.net/reveel-gamification/refer-friend-blue.png",
  taskBanner:
    "https://pulsarmoney.b-cdn.net/reveel-gamification/task-banner.png",
  revaNft: "https://pulsarmoney.b-cdn.net/reveel-gamification/nft-dark.png",
};
